import { Injector, NgModule } from '@angular/core';
import { BootstrapModuleContract } from '../support/modules/interfaces/bootstrap-module.interface';
import { PluginService } from '../plugins/services/plugin.service';
import { BootstrapModule } from '../support/modules/bootstrap-module';
import { SupportModule } from './../support/support.module';
import { FollowService } from './services/follow.service';
import { MenuService } from '../menu/services/menu.service';

@NgModule({
    imports: [SupportModule],
    exports: [],
    declarations: [],
    entryComponents: [],
    providers: [FollowService],
})
export class FollowsModule extends BootstrapModule implements BootstrapModuleContract {
    public boot(injector: Injector) {
    }

    public plugins(plugin: PluginService) {
    }

    public menus(menus: MenuService) {

    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/follows/follows.module.ts